import { useMutation } from '@apollo/client';
import { LoginInput, TokenResponse } from '../../shared/types';
import { CITRIN_LOGIN_USER, CreateLoginUserResponse, CreateLoginUserRequest } from '..';

type CreateMutationFunction = (request: LoginInput) => Promise<TokenResponse>;
export const useLoginUserMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateLoginUserResponse, CreateLoginUserRequest>(CITRIN_LOGIN_USER);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_loginUser;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
